import {
  ActionReducerMapBuilder,
  createAction,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import { DefaultUsersState, UsersState } from "../state/stateItems";
import { TUserItem, TUserSelfInvitationItem } from "@/data/types";
import {
  getAllUsersAsync,
  getSelfInvitationsAsync,
  getUserByIdAsync,
} from "../actions";

const handleGetAllUsersAsync = (
  state: UsersState,
  action: PayloadAction<{ items: TUserItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items } = action.payload;

  state.items = items;
};

const handleGetUserInvitationsAsync = (
  state: UsersState,
  action: PayloadAction<{ items: TUserSelfInvitationItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items } = action.payload;

  state.invitations = items;
};

const handleGetUserByIdAsync = (
  state: UsersState,
  action: PayloadAction<TUserItem>
) => {
  if (!action?.payload) {
    return state;
  }

  const user = action.payload;

  state.currrentUser = user;
};

const reducerBuilder = (builder: ActionReducerMapBuilder<UsersState>) => {
  builder.addCase(getAllUsersAsync.fulfilled.type, handleGetAllUsersAsync);
  builder.addCase(getUserByIdAsync.fulfilled.type, handleGetUserByIdAsync);
  builder.addCase(
    getSelfInvitationsAsync.fulfilled.type,
    handleGetUserInvitationsAsync
  );
};

export default createReducer(DefaultUsersState, reducerBuilder);
